import {ListItemIcon, ListItemText, Menu, MenuItem, Tooltip} from "@mui/material";
import React from "react";
import {useStores} from "../../../../../../stores";
import {MatPartReviewRowState} from "../../../../../../services/classes/MaterializedClasses.ts";
import {ToolbarButton} from "@mui/x-data-grid";
import {CAT_EQ_OPERATOR, CAT_NEQ_OPERATOR} from "../filters/CategoryFilter.tsx";
import FilterIcon from "../../../../../../components/icons/svg/FilterIcon.svg?react";
import NoFilterIcon from "../../../../../../components/icons/svg/NoFilterIcon.svg?react";
import CancelIcon from "../../../../../../components/icons/svg/CloseCircleIcon.svg?react";

export const ToolbarQuickFilters: React.FC = () => {
    const {categorizationReviewStore} = useStores();
    const filterController =
        categorizationReviewStore.reviewPageController.reviewPageFilterController;

    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);

    const handleOpen = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const notReviewedActive = filterController.hasFilter("state", "isAnyOf", [
        MatPartReviewRowState.input,
        MatPartReviewRowState.ai,
    ]);
    const onlyReviewedActive = filterController.hasFilter(
        "state",
        "is",
        MatPartReviewRowState.reviewed,
    );

    return (
        <>
            <Tooltip title="Quick filters">
                <ToolbarButton
                    id="toolbar-quick-filters-button"
                    color="primary"
                    onClick={handleOpen}
                >
                    <FilterIcon fontSize="small"/>
                </ToolbarButton>
            </Tooltip>
            <Menu
                id="toolbar-quick-filters-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "right",
                }}
                transformOrigin={{
                    vertical: "top",
                    horizontal: "right",
                }}
            >
                <MenuItem
                    onClick={() => {
                        filterController.toggleFilter("state", "isAnyOf", [
                            MatPartReviewRowState.input,
                            MatPartReviewRowState.ai,
                        ]);
                        handleClose();
                    }}
                >
                    <ListItemIcon>
                        {notReviewedActive ? (
                            <FilterIcon fontSize="small" color="primary"/>
                        ) : (
                            <NoFilterIcon fontSize="small"/>
                        )}
                    </ListItemIcon>
                    <ListItemText>Not reviewed</ListItemText>
                </MenuItem>
                <MenuItem
                    onClick={() => {
                        filterController.toggleFilter(
                            "state",
                            "is",
                            MatPartReviewRowState.reviewed,
                        );
                        handleClose();
                    }}
                >
                    <ListItemIcon>
                        {onlyReviewedActive ? (
                            <FilterIcon fontSize="small" color="primary"/>
                        ) : (
                            <NoFilterIcon fontSize="small"/>
                        )}
                    </ListItemIcon>
                    <ListItemText>Only reviewed</ListItemText>
                </MenuItem>
                <MenuItem
                    onClick={() => {
                        filterController.toggleCatNotEqualsPrevFilter();
                        handleClose();
                    }}
                >
                    <ListItemIcon>
                        {filterController.catNotEqualPrevFilterIsActive ? (
                            <FilterIcon fontSize="small" color="primary"/>
                        ) : (
                            <NoFilterIcon fontSize="small"/>
                        )}
                    </ListItemIcon>
                    <ListItemText>{CAT_NEQ_OPERATOR.label}</ListItemText>
                </MenuItem>
                <MenuItem
                    onClick={() => {
                        filterController.toggleCatEqualsPrevFilter();
                        handleClose();
                    }}
                >
                    <ListItemIcon>
                        {filterController.catEqualPrevFilterIsActive ? (
                            <FilterIcon fontSize="small" color="primary"/>
                        ) : (
                            <NoFilterIcon fontSize="small"/>
                        )}
                    </ListItemIcon>
                    <ListItemText>{CAT_EQ_OPERATOR.label}</ListItemText>
                </MenuItem>
                <MenuItem
                    onClick={() => {
                        filterController.clearFilters();
                        handleClose();
                    }}
                >
                    <ListItemIcon>
                        <CancelIcon fontSize="small"/>
                    </ListItemIcon>
                    <ListItemText>Clear</ListItemText>
                    {/*<Typography variant="body2" sx={{color: 'text.secondary'}}>*/}
                    {/*    <Cancel fontSize="small"/>*/}
                    {/*</Typography>*/}
                </MenuItem>
            </Menu>
        </>
    );
};
